import type {
  ChangeEvent,
  ComponentPropsWithoutRef,
  ComponentPropsWithRef,
  FunctionComponent,
  KeyboardEvent,
  SVGProps,
} from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './Icon.module.scss'

export const Icon: FunctionComponent<Props> = ({
  fill,
  width = 16,
  height = 16,
  viewBox = `0 0 ${width} ${height}`,
  children,
  iconRef,
  className,
  onClick,
  ...rest
}) => (
  <svg
    aria-hidden
    className={classnames(styles.icon, className)}
    data-testid="svg"
    fill={fill}
    focusable="false"
    height={height}
    ref={iconRef}
    tabIndex={-1}
    version="1.1"
    viewBox={viewBox}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    onClick={onClick}
    {...rest}
  >
    {children}
  </svg>
)

///////// IMPLEMENTATION /////////

type Props = {
  fill?: string
  width?: number
  height?: number
  viewBox?: string
  className?: string
  iconRef?: React.RefObject<SVGSVGElement>
  children: React.ReactNode
  onClick?: (
    event: ChangeEvent<HTMLElement> | KeyboardEvent<HTMLElement>
  ) => void
} & SVGProps<SVGSVGElement> &
  ComponentPropsWithoutRef<'svg'>

export type Icon = {
  fill?: string
  customColour?: string
  width?: number
  height?: number
  className?: string
  onClick?: (
    event: ChangeEvent<HTMLElement> | KeyboardEvent<HTMLElement>
  ) => void
  selected?: boolean
  iconRef?: ComponentPropsWithRef<typeof Icon>['iconRef']
} & SVGProps<SVGSVGElement> &
  ComponentPropsWithoutRef<'svg'>
